import {
  noGroupingId,
  ReorderItem,
  ReorderResult,
  TaskListItemTypes,
} from '@griply/types';

import { filterNewTaskChildIds } from './filter-new-task-child-ids';

export type OnNoGroupingReorderOptions = {
  updatedItems: readonly ReorderItem[];
};

export const onNoGroupingReorder = ({
  updatedItems,
}: OnNoGroupingReorderOptions): ReorderResult | null => {
  const rootItem = updatedItems.find(
    (item) => item.type === TaskListItemTypes.Root,
  );

  if (!rootItem) {
    return null;
  }

  return {
    updatedSections: [
      {
        id: noGroupingId,
        taskSorting: filterNewTaskChildIds(rootItem.children),
      },
    ],
    updatedTasks: [],
  };
};
